export default import.meta.ROLLDOWN_FILE_URL_XivDCLKvo3rsiwL$eU0pkA